import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FixedOverlay, RelativeOverlay } from '../Overlay';
import DropdownContent from './DropdownContent';

var Dropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.Overlay = _this.props.appendToBody ? FixedOverlay : RelativeOverlay;
    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpened = _this$props.isOpened,
          anchor = _this$props.anchor,
          children = _this$props.children,
          autoPositionX = _this$props.autoPositionX,
          autoPositionY = _this$props.autoPositionY,
          anchorFullWidth = _this$props.anchorFullWidth,
          closeOnClickOutside = _this$props.closeOnClickOutside,
          contentPointX = _this$props.contentPointX,
          anchorPointX = _this$props.anchorPointX,
          contentPointY = _this$props.contentPointY,
          anchorPointY = _this$props.anchorPointY,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose,
          onRequestClose = _this$props.onRequestClose,
          className = _this$props.className,
          style = _this$props.style,
          padding = _this$props.padding,
          overlayClassName = _this$props.overlayClassName,
          overlayStyle = _this$props.overlayStyle,
          appendToBody = _this$props.appendToBody,
          tabIndex = _this$props.tabIndex,
          showArrow = _this$props.showArrow;
      var dropdownProps = {
        onRequestClose: onRequestClose,
        closeOnClickOutside: closeOnClickOutside,
        anchorFullWidth: anchorFullWidth,
        className: className,
        style: style,
        padding: padding,
        tabIndex: tabIndex,
        showArrow: showArrow
      };
      var overlayProps = {
        anchor: anchor,
        contentPointX: contentPointX,
        anchorPointX: anchorPointX,
        autoPositionX: autoPositionX,
        autoPositionY: autoPositionY,
        contentPointY: contentPointY,
        anchorPointY: anchorPointY,
        isOpened: isOpened,
        onContentOpen: onOpen,
        onContentClose: onClose,
        content: React.createElement(DropdownContent, dropdownProps, children)
      };

      if (appendToBody) {
        overlayProps.containerNodeClassName = overlayClassName;
        overlayProps.containerNodeStyle = overlayStyle;
      } else {
        overlayProps.className = overlayClassName;
        overlayProps.style = overlayStyle;
      }

      return React.createElement(this.Overlay, overlayProps);
    }
  }]);

  return Dropdown;
}(PureComponent);

Dropdown.defaultProps = {
  closeOnClickOutside: true,
  contentPointX: 'left',
  anchorPointX: 'left',
  autoPositionX: false,
  contentPointY: 'top',
  anchorPointY: 'bottom',
  autoPositionY: true,
  appendToBody: false,
  tabIndex: null
};
export { Dropdown as default };
Dropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Функция, возвращающая элемент, к которому привязывается Dropdown. Принимает коллбек для передачи ссылки на ноду в качестве аргумента
   */
  anchor: PropTypes.func.isRequired,

  /**
   * Контент дропдауна
   */
  children: PropTypes.node.isRequired,

  /**
   * CSS класс для контейнера Dropdown
   */
  className: PropTypes.string,

  /**
   * Стили для контейнера Dropdown
   */
  style: PropTypes.object,

  /**
   * CSS класс контейнера оверлея
   */
  overlayClassName: PropTypes.string,

  /**
   * Стили для контейнера оверлея
   */
  overlayStyle: PropTypes.object,

  /**
   * Показывать ли дропдаун
   * Укажите этот параметр, если хотите контроллировать состояние открытия
   */
  isOpened: PropTypes.bool,

  /**
   * Колбек открытия попапа
   */
  onOpen: PropTypes.func,

  /**
   * Колбек закрытия попапа
   */
  onClose: PropTypes.func,

  /**
   * Коллбек вызывающийся при клике вне контента.
   * Используется в случае если необходим полный контроль состояния открытия/закрытия из вне.
   */
  onRequestClose: PropTypes.func,

  /**
   * Закрывать ли при клике вне контента
   */
  closeOnClickOutside: PropTypes.bool,

  /**
   * Точка прикрепления контента по оси X
   */
  contentPointX: PropTypes.oneOf(['left', 'right', 'center']),

  /**
   * Точка прикрепления anchor по оси X
   */
  anchorPointX: PropTypes.oneOf(['left', 'right', 'center']),

  /**
   * Автоматическое позиционирование по оси X (если выходит за пределы экрана)
   */
  autoPositionX: PropTypes.bool,

  /**
   * Точка прикрепления контента по оси Y
   */
  contentPointY: PropTypes.oneOf(['top', 'bottom', 'center']),

  /**
   * Точка прикрепления anchor по оси Y
   */
  anchorPointY: PropTypes.oneOf(['top', 'bottom', 'center']),

  /**
   * Автоматическое позиционирование по оси Y (если выходит за пределы экрана)
   */
  autoPositionY: PropTypes.bool,

  /**
   * Тянуть контент на всю ширину anchor
   */
  anchorFullWidth: PropTypes.bool,

  /**
   * Вставлять ли dropdown внутри body
   */
  appendToBody: PropTypes.bool,

  /**
   * Паддинги
   * Если паддинг не нужен, нужно передать false
   */
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  /**
   * Порядок фокусировки элемента
   */
  tabIndex: PropTypes.number,

  /**
   * Показать стрелку
   */
  showArrow: PropTypes.bool
} : {};